import { useMemo } from "react";
import { createPortal } from "react-dom";
import { AnimationScreenProps } from "types/animationScreen";

const AnimationScreen: React.FC<AnimationScreenProps> = ({ id, children, animation }) => {
    const { mountTo, options } = animation;
    const { background, touchable } = options;

    const portalRoot = useMemo(() => mountTo ?? (typeof document !== 'undefined' ? document.getElementById('hMainContainer') : null), [mountTo]);
    if (!portalRoot) return null;

    const content = (
      <div data-component="AnimationScreen" className="fixed inset-0 z-[102]" style={{ background, pointerEvents: touchable ? 'unset' : 'none' }}>
        {children}
      </div>
    );

    return createPortal(content, portalRoot);
};

export default AnimationScreen;